'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_CONTENT = exports.EDIT_ITEM = exports.ADD_CONTENT = exports.REMOVE_QUOTATION = exports.EDIT_QUOTATION = exports.ADD_QUOTATION = exports.QUOTATIONS = undefined;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QUOTATIONS = exports.QUOTATIONS = _constantsAnalytics2.default.CATEGORIES.QUOTATIONS;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS;
var ADD_QUOTATION = _analyticsConstants$E.ADD_QUOTATION,
    EDIT_QUOTATION = _analyticsConstants$E.EDIT_QUOTATION,
    REMOVE_QUOTATION = _analyticsConstants$E.REMOVE_QUOTATION;
exports.ADD_QUOTATION = ADD_QUOTATION;
exports.EDIT_QUOTATION = EDIT_QUOTATION;
exports.REMOVE_QUOTATION = REMOVE_QUOTATION;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS;
var ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;
exports.ADD_CONTENT = ADD_CONTENT;
exports.EDIT_ITEM = EDIT_ITEM;
exports.REMOVE_CONTENT = REMOVE_CONTENT;


function composeQuotationEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: QUOTATIONS,
    gtmAction: action
  });
}

function composeAddQuotationEvent() {
  return (0, _compose.composeAnalytics)([composeQuotationEvent(ADD_QUOTATION, ADD_CONTENT)]);
}

function composeEditQuotationEvent() {
  return (0, _compose.composeAnalytics)([composeQuotationEvent(EDIT_QUOTATION, EDIT_ITEM)]);
}

function composeRemoveQuotationEvent() {
  return (0, _compose.composeAnalytics)([composeQuotationEvent(REMOVE_QUOTATION, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddQuotationEvent: composeAddQuotationEvent,
  composeEditQuotationEvent: composeEditQuotationEvent,
  composeRemoveQuotationEvent: composeRemoveQuotationEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/quotationsEventComposer.js
// module id = 584
// module chunks = 0 2 4 5 6 8 9 10 11